"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _l10n = require("@nextcloud/l10n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function t(text) {
  return (0, _l10n.translate)('nextcloud-moment', text);
}

_moment.default.locale((0, _l10n.getLocale)());
/*
TODO: make it work
moment.updateLocale(
    getLocale(), // moment.locale()?
    {
        parentLocale: getLocale(), // moment.locale()?
        relativeTime: Object.assign(
            // @ts-ignore
            moment.localeData(getLocale())._relativeTime,
            {
                s: t('seconds ago'),
            }
        )
    })
*/


var _default = _moment.default;
exports.default = _default;
//# sourceMappingURL=index.js.map